module.exports = __webpack_public_path__ + "static/media/leadsWhite.ce919c8a.svg";